<template>
  <div class="d-flex justify-content-center align-items-center">
    <div></div>
    <b-pagination
        :page-range="9" :limit="pagination_object.limit"
        v-model="pagination_object.current_page"
        :total-rows="pagination_object.total"
        :per-page="pagination_object.per_page"
        aria-controls="itemList"
        align="center"
        @change="goToPage"
        v-if="pagination_object.total > 0"
        :key="pagination_object.current_page"
    ></b-pagination>
    <b-form-select
        id="perPageSelect"
        v-model="pagination_object.per_page"
        :options="[10, 25, 50, 100]"
        @change="handlePerPageUpdate($event)"
        size="sm" class="ml-3" style="width: 65px; height: 35px; margin-bottom:1rem"
    />
  </div>
</template>

<script>

export default {
  name: 'PaginationWithPerPage',
  props: {
    pagination_object: {
      type: Object,
      default: function() {
        return {
          currentPage: 1, perPage: 10, total: 50, limit: 11
        }
      }
    }
  },
  methods: {
    goToPage(page) {
      this.$emit('pagination-updated', page)
      console.log('hey', page)
    },
    handlePerPageUpdate() {
      //1 is the page number as when per page option updated then navigate user to first page with required number pf rows per page
      this.$emit('pagination-updated', 1)
    }
  }
}
</script>

<style scoped lang="scss">

</style>